import {
    create
} from "zustand";
import api from "../../../api/axios";

export const useEmployees = create((set, get) => ({
    employees: [],
    statuses: [],



    // APIS
    getStatuses: () => {
        api.get('userstatus').then(res => {
            set({
                statuses: res.data
            })
        })
    },
    getEmployees: () => {
        api.get('employees').then(res => {
            set({
                employees: res.data.data
            })
        })
    },
    addEmployee: (data) => {
        api.post('employees', data).then(res => {
            set({
                employees: [...get().employees, res.data.data]
            })
        })
    },
    editEmp: (data) => {
        api.put(`/employees/${data.id}`, data).then(() => {
            set({
                employees: get().employees.map(e => e.id === data.id ? data : e)
            })
        })
    },
    deleteEmp: (rec) => {
        api.delete(`/employees/${rec.id}`).then(() => {
            set({
                employees: get().employees.filter(e => e.id !== rec.id)
            })
        })
    }
}))